/**
 * @file index.tsx
 *
 * @fileoverview Renders register link on the login page.
 */

import React from 'react';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { FormattedMessage } from 'react-intl';
import Link from '~/jobiqo/components/Link';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { ROLE_APPLICANT, ROLE_RECRUITER } from '~/jobiqo/lib/auth';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import EducationIcon from '~/jobiqo/components/Icons/EducationIcon';
import { OfficeIcon } from '~/vcl/icons/Office';
import { ButtonDiv } from '~/vcl/atoms/01-forms/01-button/03-button-div';
import styles from './registerLink.module.scss';

export default function LoginRegisterLink() {
  const { RESUME, ORGANIZATIONS } = useFrontendConfig();
  const APPLICANT_FEATURE_ACTIVE = RESUME.APPLICANT_FEATURE_ACTIVE;
  const RECRUITER_FEATURE_ACTIVE = ORGANIZATIONS.RECRUITER_FEATURE_ACTIVE;
  return (
    <div style={{ maxWidth: '400px' }}>
      <Text tag="div" fontSize={2} textAlign="center">
        <FormattedMessage
          id="login_no_account"
          defaultMessage={`Don't have an account?`}
        />
        <Spacing size="medium" />
        {APPLICANT_FEATURE_ACTIVE && RECRUITER_FEATURE_ACTIVE ? (
          <FlexItems flexWrap="wrap" gap={5} justifyContent="space-around">
            <Link
              data-test-id="user_register_applicant"
              href={`/user/register/${ROLE_APPLICANT}`}
              className={styles.registerLink}
            >
              <ButtonDiv buttonStyle="primary" bordered={true}>
                <EducationIcon />
                <span>
                  <FormattedMessage id="applicant" defaultMessage="Applicant" />
                </span>
              </ButtonDiv>
            </Link>
            <Link
              data-test-id="user_register_recruiter"
              href={`/user/register/${ROLE_RECRUITER}`}
              className={styles.registerLink}
            >
              <ButtonDiv buttonStyle="primary" bordered={true}>
                <OfficeIcon />
                <span>
                  <FormattedMessage id="recruiter" defaultMessage="Recruiter" />
                </span>
              </ButtonDiv>
            </Link>
          </FlexItems>
        ) : (
          <Link
            href={
              APPLICANT_FEATURE_ACTIVE
                ? `/user/register/${ROLE_APPLICANT}`
                : `/user/register/${ROLE_RECRUITER}`
            }
          >
            <FormattedMessage
              id="register_without_role"
              defaultMessage="Register"
            />{' '}
          </Link>
        )}
      </Text>
    </div>
  );
}

export { LoginRegisterLink };
